import { useState } from "react";
import { Plus } from "lucide-react";
import { adminApi, formatApiError } from "../../lib/api";
import { RowActions, useCrudList } from "./AdminMagazines";
import { inputCls } from "../../components/admin/fields";
import { toast } from "sonner";

export default function AdminCategories() {
  const { items, reload, remove } = useCrudList("categories");
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  const add = async (e) => {
    e.preventDefault();
    try {
      await adminApi.post("/categories", { name, description });
      setName(""); setDescription("");
      toast.success("Category added.");
      reload();
    } catch (err) {
      toast.error(formatApiError(err));
    }
  };

  return (
    <div className="max-w-2xl" data-testid="admin-categories-page">
      <h1 className="text-xl font-bold text-zinc-900 mb-6">Categories</h1>
      <form onSubmit={add} className="bg-white border border-zinc-200 rounded-md p-4 flex gap-3 mb-6 flex-wrap" data-testid="category-form">
        <input required value={name} onChange={(e) => setName(e.target.value)} placeholder="Category name" className={inputCls + " flex-1 min-w-[160px]"} data-testid="category-name-input" />
        <input value={description} onChange={(e) => setDescription(e.target.value)} placeholder="Description (optional)" className={inputCls + " flex-1 min-w-[200px]"} data-testid="category-desc-input" />
        <button type="submit" className="inline-flex items-center gap-1.5 bg-zinc-900 text-white text-sm font-semibold px-4 py-2 rounded-md" data-testid="category-add-btn">
          <Plus className="w-4 h-4" /> Add
        </button>
      </form>
      <div className="bg-white border border-zinc-200 rounded-md divide-y divide-zinc-100" data-testid="categories-list">
        {items.map((c) => (
          <div key={c.id} className="flex items-center justify-between px-4 py-3" data-testid={`category-row-${c.slug}`}>
            <div>
              <span className="text-sm font-medium text-zinc-900">{c.name}</span>
              <span className="text-xs text-zinc-400 ml-2">/{c.slug}</span>
              {c.description && <p className="text-xs text-zinc-500 mt-0.5">{c.description}</p>}
            </div>
            <RowActions onDelete={() => remove(c.id)} testId={`category-${c.slug}`} />
          </div>
        ))}
      </div>
    </div>
  );
}
